import React, { useEffect, useState } from "react";
import { BoardIdentifierNumber } from "../../../models/boardUserBisk";

interface ContainerProps {
    result: BoardIdentifierNumber;
    blurred?: boolean;
}

const BoardIDXInfoCard: React.FC<ContainerProps> = ({ result, blurred }) => {
    const [blurredClass, setBlurredClass] = useState<string>('blur-lg');

    useEffect(() => {
        if (blurred) {
            setBlurredClass('blur-lg');
        } else {
            setBlurredClass('');
        }
    }, [blurred]);

    return (
        <div className={"flex flex-col border-b border-gray-900 " + blurredClass}>
            <div className="flex items-center justify-between px-4 py-3">
                <div className="font-bold">
                    {result.id}
                </div>
                <div className="font-bold">
                    {result.number}
                </div>
            </div>
        </div>
    )
};

export default BoardIDXInfoCard;